import clsx from 'clsx';

export const Button = ({
  inverted = false,
  disabled = false,
  isLoading = false,
  small = false,
  xsmall = false,
  square = false,
  className = '',
  ...props
}) => {
  return (
    <div
      className={clsx(
        'relative font-medium',
        disabled || isLoading ? 'cursor-default' : 'cursor-pointer',
      )}
    >
      <button
        className={clsx(
          'flex cursor-pointer items-center justify-center gap-4 rounded-md border text-base shadow transition-all',
          small ? 'px-2 py-1 min-w-40 ' : xsmall ? 'px-4 py-1' : square ? 'p-1' : 'px-4 py-2 min-w-40 ',
          inverted
            ? 'border-blue bg-white text-blue hover:slateBlue'
            : 'border-blue bg-blue text-white hover:slateBlue',
          disabled || isLoading ? 'pointer-events-none opacity-50' : 'opacity-100', className
        )}
        {...props}
      ></button>
    </div>
  );
};
